import { render } from "./atCookieBanner.vue?vue&type=template&id=991dcbf2"
import script from "./atCookieBanner.vue?vue&type=script&lang=js"
export * from "./atCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__